/**
 * Configurações do Control Panel
 */

// Número de itens por página
export const ITEMS_PER_PAGE = 5;

// Delay para chamar getLogsRead após carregar logs (em milissegundos)
export const LOGS_READ_DELAY_MS = 1000;

// Configurações de paginação
export const PAGINATION_CONFIG = {
  initialItems: ITEMS_PER_PAGE,
  initialPage: 0,
  incrementBy: ITEMS_PER_PAGE,
};
